module.exports = __webpack_public_path__ + "static/media/risk.27bb4d56.svg";